













import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { viewEditingStateModule } from '@/store/state/viewEditingState';

import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
  components: {
    IconButton,
    NormalButton,
    ConfirmDialog,
  },
})
export default class BackToMenuButton extends Vue {

  private 確認ダイアログを表示する(): void {
    this.$modal.show('ログインに戻る');
  }

  private 確認ダイアログを閉じる(): void {
    this.$modal.hide('ログインに戻る');
  }

  private メッセージ(): string {
    if (viewEditingStateModule.画面を編集中である) {
      return '編集中のデータは破棄されますが、よろしいですか？';
    }
    return 'メニューへ戻ります。よろしいですか？';
  }

  private メニューへ戻る(): void {
    this.確認ダイアログを閉じる();
    this.$router.push({name : 'home'});
  }
}
